import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { TitleRegistrationService } from '../../titleregistration/services/titleregistration.service';
import { CustomerVehicleComponent } from './customer-vehicle.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        CustomerVehicleComponent
    ],
    providers: [
        TitleRegistrationService
    ],
    imports: [
        CommonModule,
        SharedPipesModule,
        TableModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'})
    ],
    exports: [
        CustomerVehicleComponent
    ]
})

export class CustomerVehicleModule {}
